import React from 'react'

const Divider = () => {
  return <hr className="border-t-1 mt-6 h-6 border-gray-200 md:mt-12 md:h-12" />
}

export default Divider
